var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApkUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "38px",
    viewBox: "0 0 38 38",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "05C510A7-E3EC-4AD4-9855-E98CB2B3C041@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "App-Store-Deployment---Create-App---Release-Details-1",
    transform: "translate(-851.000000, -1208.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1715
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(626.000000, 558.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Full-description-Copy-4",
    transform: "translate(0.000833, 500.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    stroke: "#D8D8D8",
    fill: "#FFFFFF",
    transform: "translate(244.000000, 164.500000) scale(-1, 1) translate(-244.000000, -164.500000) ",
    x: 0.5,
    y: 0.5,
    width: 487,
    height: 328,
    rx: 5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 150.000000)",
    fill: "#3365FF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(225.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.0003689,22.7418873 L38.0003689,30.1968021 C38.0003689,32.2782077 37.1788299,34.243519 35.6866469,35.7112831 C34.1944638,37.1873396 32.2160639,38 30.1119181,38 L7.88845072,38 C5.78430499,38 3.79752197,37.1873396 2.313722,35.7112831 C0.821538969,34.2352265 0,32.2782077 0,30.1968021 L0,22.7418873 C0,22.1282458 0.502983042,21.6388889 1.11494574,21.6388889 C1.7352915,21.6388889 2.22989149,22.1365382 2.22989149,22.7418873 L2.22989149,30.1968021 C2.22989149,33.2815945 4.76995585,35.7859152 7.88845072,35.7942076 L30.1119181,35.7942076 C33.230413,35.7942076 35.7620943,33.2815945 35.7704774,30.1968021 L35.7704774,22.7418873 C35.7704774,22.1282458 36.2734604,21.6388889 36.8854231,21.6388889 C37.4973858,21.6306986 38.0003689,22.1282458 38.0003689,22.7418873 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8235375,12.5923789 C30.6131018,12.8100663 30.3269091,12.9356552 30.0154642,12.9356552 C29.7208542,12.9356552 29.4514964,12.8268115 29.2410607,12.6258693 L21.5391122,4.95657469 L20.3859243,3.81790212 L20.3859243,27.914223 C20.3859243,28.5254222 19.8808785,29.0277778 19.2664061,29.0277778 C18.6519337,29.0277778 18.1468879,28.5254222 18.1468879,27.914223 L18.1468879,3.81790212 L16.9937,4.95657469 L9.2917515,12.6174967 C9.08131575,12.8184389 8.80354056,12.9272826 8.51734794,12.9272826 C8.22273789,12.9272826 7.9449627,12.8184389 7.73452695,12.6174967 C7.51567376,12.4081819 7.39782974,12.1318864 7.38941231,11.830473 C7.38099488,11.5374323 7.49042147,11.2527642 7.70085723,11.0350768 L18.4751677,0.326531103 C18.6856034,0.117216293 18.971796,0 19.2664061,0 C19.5610161,0 19.8472088,0.117216293 20.0576445,0.326531103 L30.8235375,11.0350768 C31.244409,11.4788242 31.244409,12.1570041 30.8235375,12.5923789 Z",
    id: "Path"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApkUploadIcon);
export default __webpack_public_path__ + "static/media/apk-upload-icon.436ede6c99f2e242227aa422360f55c3.svg";
export { ForwardRef as ReactComponent };